<template>
	<div>
		<div class="jinbu flex  align-items align-content">
			<div class="pointer" @click="shouye">首页</div>
			<div>/意见反馈</div>
		</div>
	
	<div class="w1200" style="padding: 20px;">
		<div class="flex benben-flex-layout flex-wrap align-center">
			<div class="feedback_0 pointer" @click="caozuo(1)">帮助与反馈</div>
			<div class="feedback_0 feedback_5" v-if="feed_type != 1">></div>
			<div class="feedback_0" v-if="feed_type == 2">帮助详情</div>
			<div class="feedback_0 pointer" @click="caozuo(2)" v-if="feed_type == 3 || feed_type == 4">意见反馈</div>
			<div class="feedback_0 feedback_5" v-if="feed_type == 4">></div>
			<div class="feedback_0" v-if="feed_type == 4">反馈记录</div>
			<div class="flex benben-flex-layout flex-wrap align-center pointer feedback_1"v-if="feed_type == 1 || feed_type == 2" @click="caozuo(2)">
				<img class="feedback_2" src="../../static/image/23.png" alt="" srcset="">
				<div>意见反馈</div>
			</div>
			<div class="flex benben-flex-layout flex-wrap align-center pointer feedback_1" v-if="feed_type == 3" @click="caozuo(3)">
				<img class="feedback_2" src="../../static/image/23.png" alt="" srcset="">
				<div>反馈记录</div>
			</div>
		</div>
		
		<div class="" v-if="feed_type == 1">
			<template v-for="(item,index) in tableData1">
				<div class="flex benben-flex-layout  align-center pointer feedback_4" @click="post64219c5dc8d0d(item.aid)">
					<div class="flex-sub">{{item.title}}</div>
					<img class="feedback_3" src="../../static/image/24.png" alt="" srcset="">
				</div>
			</template>
			
			<div class="video_4_3">
				<el-pagination @size-change="handleSizeChange1" @current-change="handleCurrentChange1" v-if="total1 > 0"
					:current-page.sync="page1" :page-size="page_size1" layout="total, sizes,prev, pager, next, jumper" :total="total1">
				</el-pagination>
			</div>
		</div>
		<div class="feedback_6" v-if="feed_type == 2">
			<div class="feedback_7">{{detail.title}}</div>
			<div class="feedback_8">
				<div class="content-h" v-html="detail.content"></div>
			</div>
		</div>
		<div class="feedback_6" v-if="feed_type == 3">
			<div class="feedback_9">反馈类型</div>
			<div class="flex wrap">
				<template v-for="(item,index) in type_list">
					<div class="pointer" @click="type_aid = item.aid" :class="type_aid == item.aid ? 'feedback_11' : 'feedback_10'">{{item.title}}</div>
				</template>
			</div>
			<div class="feedback_9">问题描述</div>
			<el-input class="feedback_12" type="textarea" placeholder="请输入内容" resize="none" maxlength="300" show-word-limit v-model="textarea"></el-input>
		    <div class="xin_5 flex flex-wrap">
		    	<div class="flex flex-wrap" >
		    		<div class="xin_2" v-for="(item,index) in img_lit" >
		    			<img class="xin_3" :src="item.path" />
		    			<img class="xin_4 pointer" @click="shanchu(index)" src="../../static/image/26.png">
		    		</div>
		    	</div>
		    	  <!-- list-type="picture-card" -->
		    	<el-upload v-if="img_lit.length < 6"
		    	  action="https://yufabu.saizhuge.net/api/m15414/5d5fa8984f0c2"
		    	  :on-preview="handlePictureCardPreview"
				  list-type="text"
		    	  :on-success="chenggong"
		    	  :on-remove="hadleRemove" >
		    	  <img class="feedback_13" src="../../static/image/25.png">
		    	</el-upload>
		    </div>
			<div class="feedback_14">请上传应用截图，最多上传6张</div>
			<div class="pointer card_5" @click="tijiao">提交</div>
		</div>
		<div class="" v-if="feed_type == 4">
			<template v-for="(item,index) in tableData2">
				<div class="feedback_15 flex">
					<img class="feedback_16" :src="item.avatar">
					<div class="flex-sub">
						<div class="feedback_17">{{item.body}}</div>
					    <div v-if="item.thumb && item.thumb.length > 0">
							<template v-for="(itm,inex) in item.thumb">
								<img class="feedback_18" :src="itm">
							</template>
						</div>
						<div class="feedback_19">反馈类型：{{item.type}}</div>
						<div class="feedback_19">反馈时间：{{item.create_time}}</div>
						
						<div class="flex flex-sub feedback_20" v-if="item.replay">
							<div class="feedback_21">平台回复：</div>
							<div class="flex-sub">{{item.replay}}</div>
						</div>
					</div>
				</div>
			</template>
			<div class="video_4_3">
				<el-pagination @size-change="handleSizeChange2" @current-change="handleCurrentChange2" v-if="total2 > 0"
					:current-page.sync="page2" :page-size="page_size2" layout="total, sizes,prev, pager, next, jumper" :total="total2">
				</el-pagination>
			</div>
			
		</div>
	</div>
	</div>
</template>

<script>
	export default {
		components: {},
		data() {
			return {
				textarea:'',
				feed_type:1,
				page1:1,
				page_size1:10,
				total1:0,
				page2:1,
				page_size2:10,
				total2:0,
				detail:'',
				type_list:[],
				type_aid:'',
				img_lit:[],
				tableData1:[],
				tableData2:[],
				stop_type:false,
			}
		},
		created() {
			// this.post641568f1b6f87()
			this.post6414719bdc956()
			this.post641472eb35317()
			this.ordeList()
		},
		methods:{
			caozuo(type){
				if(type == 1){ //帮助与反馈
					this.feed_type = 1
				}else if(type == 2){ // 意见反馈
					this.type_aid = ''
					this.textarea = ''
					this.img_lit = []
					this.feed_type = 3
				}else if(type == 3){ //反馈记录
					this.feed_type = 4
				}
			},
			// 意见反馈类型
			post6414719bdc956(aid){
				this.$api.post(this.$apiUrls.post6414719bdc956, {}).then((res) => {
					if (res.code == 1) {
						this.type_list = res.data
					} else {
						this.$message.error(res.msg);
						return
					}
				})
			},
			// 提交
			tijiao(){
				if(!this.type_aid){
					this.$message.error('请选择反馈类型');
					return
				}
				if(!this.textarea){
					this.$message.error('请填写问题描述');
					return
				}
				
				if(this.stop_type){
					return
				}
				this.stop_type = true
				let list = []
				if(this.img_lit.length > 0){
					for (var i = 0; i < this.img_lit.length; i++) {
						list.push(this.img_lit[i].path) 
					}
				}
				
				this.$api.post(this.$apiUrls.post6414724b96f3f, {
					type_id:this.type_aid,
					body:this.textarea,
					thumb:list.toString()
				}).then((res) => {
					if (res.code == 1) {
						this.type_list = res.data
						this.stop_type = false
						this.$message.success('提交成功！');
						this.page2 = 1
						this.post641472eb35317()
						this.caozuo(1)
					} else {
						this.$message.error(res.msg);
						this.stop_type = false
						return
					}
				})
			},
			shouye(){
				this.$router.push({
					name: 'index',
				});
			},
			// 上传成功
			chenggong(file){
				// console.log(file,'返沪参数')
				this.img_lit.push(file.data[0]);
			},
			hadleRemove(file, fileList) {
			    // console.log(file, fileList);
			},
			handlePictureCardPreview(file) {
				
				// this.dilogVisible = true;
			},
			// 删除图片
			shanchu(index){
				this.img_lit.splice(index,1)
			},
			handleSizeChange1(val) {
				// console.log(`每页 ${val} 条`,this.page);
				this.page_size1 = val
				this.ordeList()
			},
			handleCurrentChange1(val) {
				// console.log(`当前页: ${val}`);
				this.page1 = val
				this.ordeList()
			},
			
			// 列表
			ordeList() {
				let page = {
					size: this.page_size1,
					page: this.page1,
					category_id:2,
				}
				this.$api.post(this.$apiUrls.post64219a95b6200, page).then((res) => {
					if (res.code == 1) {
						this.tableData1 = res.data.data
						this.total1 = res.data.total
					// console.log(this.total,res,123)
					} else {
						this.$message.error(res.msg);
						return
					}
				})
			},
			// 详情
			post64219c5dc8d0d(aid){
				this.$api.post(this.$apiUrls.post64219c5dc8d0d, {
					article_id:aid
				}).then((res) => {
					if (res.code == 1) {
						this.detail = res.data
						this.feed_type = 2
					} else {
						this.$message.error(res.msg);
						return
					}
				})
			},
			handleSizeChange2(val) {
				// console.log(`每页 ${val} 条`,this.page);
				this.page_size2 = val
				this.post641472eb35317()
			},
			handleCurrentChange2(val) {
				// console.log(`当前页: ${val}`);
				this.page2 = val
				this.post641472eb35317()
			},
			post641472eb35317(){
				let page = {
					size: this.page_size2,
					page: this.page2,
				}
				this.$api.post(this.$apiUrls.post641472eb35317, page).then((res) => {
					if (res.code == 1) {
						this.tableData2 = res.data.data
						this.total2 = res.data.total
					} else {
						this.$message.error(res.msg);
						return
					}
				})
			},
			post641568f1b6f87(){
				this.$api.post(this.$apiUrls.post641568f1b6f87, {
					column_id: 1
				}).then((res) => {
					// console.log(res, 123)
					if (res.code == 1) {} else {
						this.$message.error(res.msg);
						return
					}
				})
			},
		},
	}
</script>

<style  lang="scss" scoped>
	::v-deep {
		.video_4_3{
			
			.number{
				width: 32px;
				height: 32px;
				border: 1px solid rgba(0,0,0,0.15);
				margin: 0 8px 0 0;
			}
			.active{
				border: 1px solid #004EA1;
				background: #004EA1;
				color: #FFFFFF;
			}
			.el-icon-arrow-right,
			.el-icon-arrow-left{
				width: 32px;
				height: 32px;
				border: 1px solid rgba(0,0,0,0.15);
				line-height: 32px;
			}
		}
		.el-textarea__inner{
			height: 200px;
			width: 600px;
			background: #F8F8F8;
		}
		.el-textarea .el-input__count{
			background: #F8F8F8;
		}
		.xin_5 .el-upload--picture-card{
			width: 96px;
			height: 96px;
			line-height: 96px;
			// margin-right: 10px;
			border: 0;
		}
		.el-upload-list{
			display: none !important;
		}
	}
	.feedback_0{
		font-weight: bold;
		font-size: 18px;
		color: #333333;
	}
	.feedback_1{
		width: 148px;
		height: 48px;
		background: #004EA1;
		border-radius: 8px 8px 8px 8px;
		font-weight: 400;
		font-size: 16px;
		color: #FFFFFF;
		margin-left: auto;
	}
	.feedback_2{
		width: 18px;
		height: 18px;
		margin: 0 12px 0 28px;
	}
	.feedback_3{
		width: 16px;
		height: 16px;
		margin: 0 0 0 32px;
	}
	.feedback_4{
		font-weight: 400;
		font-size: 16px;
		color: #333333;
		margin: 32px 0 0 0;
	}
	.video_4_3{
		text-align: center;
		margin-top: 20px;
	}
	.feedback_5{
		margin: 0 20px;
	}
	.feedback_6{
		margin: 20px 0 0 0;
	}
	.feedback_7{
		font-weight: bold;
		font-size: 16px;
		color: #333333;
	}
	.feedback_8{
		margin: 20px 0 0 0;
	}
	.feedback_9{
		font-weight: bold;
		font-size: 16px;
		color: #333333;
		margin: 0 0 20px 0;
	}
	.feedback_10{
		margin:0 20px 20px 0;
		padding: 10px 22px;
		border: 1px solid #F8F8F8;
		background: #F8F8F8;
		border-radius: 8px 8px 8px 8px;
	}
	.feedback_11{
		margin:0 20px 20px 0;
		padding: 10px 22px;
		border: 1px solid #004EA1;
		background: #E5EDF5;
		color: #004EA1;
		border-radius: 8px 8px 8px 8px;
	}
	.feedback_12{
		height: 200px;
		width: 600px;
		background: #F8F8F8;
	}
	.xin_2{
		position: relative;
		width: 96px;
		height: 96px;
		margin:0 10px 10px 0;
	}
	.xin_3{
		width: 100px;
		height: 100px;
		
	}
	.xin_4{
		position: absolute;
		top: 0;
		right: 0;
		width: 24px;
		height: 24px;
	}
	.xin_5{
		margin: 20px 0 0 0;
	}
	.feedback_13{
		width: 96px;
		height: 96px;
	}
	.feedback_14{
		font-weight: 400;
		font-size: 14px;
		color: #CCCCCC;
	}
	.card_5{
		width: 148px;
		height: 48px;
		background: #004EA1;
		border-radius: 8px 8px 8px 8px;
		text-align: center;
		line-height: 48px;
		font-weight: 400;
		font-size: 16px;
		color: #fff;
		margin: 100px 0 0 0px;
	}
	.feedback_15{
		margin: 20px 0 0 0;
	}
	.feedback_16{
		width: 50px;
		height: 50px;
		margin: 0 20px 0 0;
	}
	.feedback_17{
		font-weight: 400;
		font-size: 16px;
		color: #333333;
	}
	.feedback_18{
		width: 120px;
		height: 120px;
		margin: 10px 10px 0 0;
	}
	.feedback_19{
		font-weight: 400;
		font-size: 14px;
		color: #999999;
		margin: 20px 0 0 0;
	}
	.feedback_20{
		background: #F8F8F8;
		border-radius: 8px 8px 8px 8px;
	    font-weight: 400;
	    font-size: 14px;
	    color: #000;
		padding: 10px 14px;
		margin: 20px 0 0 0;
	}
	.feedback_21{
		color: #004EA1;
	}
</style>